export default {
  GET_CURRENT_PRODUCT_MAP: 'product/GET_CURRENT_PRODUCT_MAP',
}
